import { QESButton } from "@app/shared/qes-standards";
import { FC, useContext, useEffect, useState } from "react";
import { ServiceAreaEditorContext } from "./ServiceAreaEditorContext";
import { CheckboxStateEnum } from "@app/shared/qes-standards/forms/Checkbox";

export const DownloadServiceAreaButton: FC = () => {
  const editorContext = useContext(ServiceAreaEditorContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isServiceAreaEmpty, setIsServiceAreaEmpty] = useState(true);

  useEffect(() => {
    const noSelection = editorContext.stateLookup && Object.keys(editorContext.stateLookup)
      .every((stateAbbreviation) =>
        editorContext.stateLookup[stateAbbreviation].checkboxState === CheckboxStateEnum.Unchecked);
    setIsServiceAreaEmpty(noSelection);
  }, [editorContext.stateLookup]);

  const handleClick = async () => {
    setIsDownloading(true);
    await editorContext.handleDownloadServiceAreaClick();
    setIsDownloading(false);
  }

  const spinner = (
    <div className="spinner-border spinner-border-sm" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );

  return (
    <QESButton
      qesTestId="download-service-area-button"
      qesType="secondary"
      onClick={handleClick}
      disabled={isDownloading || isServiceAreaEmpty}
    >
      Download Service Area {isDownloading && spinner}
    </QESButton>
  );
}
